// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { APPBaseElement } from './APPBaseElement';
import { EnumRoleType } from '../../../../../com/MetaPattern/MDA/MD/APPModel/EnumRoleType';
import { APPComponent } from './APPComponent';
import { MenuContain } from './MenuContain';
import { MenuItem } from './MenuItem';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 菜单集 实体类
 * 菜单集
 */
export class MenuSet extends APPBaseElement {
  /** 图标地址 : 图标地址 */
  private _icon: string;

  /** 设置：图标地址 */
  public get icon() {
    return this._icon;
  }

  /** 获取：图标地址 */
  public set icon(value: string) {
    this._icon = value;
  }

  /** 是否启用 : 是否启用 */
  private _isValid: boolean;

  /** 设置：是否启用 */
  public get isValid() {
    return this._isValid;
  }

  /** 获取：是否启用 */
  public set isValid(value: boolean) {
    this._isValid = value;
  }

  /** 编码 : 编码，仅用于顶级菜单，用于根据编码获取一个菜单树 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 是否默认 : 是否默认的菜单集，只有根菜单集有效 */
  private _isDefault: boolean;

  /** 设置：是否默认 */
  public get isDefault() {
    return this._isDefault;
  }

  /** 获取：是否默认 */
  public set isDefault(value: boolean) {
    this._isDefault = value;
  }

  /** 显示顺序 : 显示顺序，升序 */
  private _displaySequence: number;

  /** 设置：显示顺序 */
  public get displaySequence() {
    return this._displaySequence;
  }

  /** 获取：显示顺序 */
  public set displaySequence(value: number) {
    this._displaySequence = value;
  }

  /** 所属角色 : 仅作用于根菜单。菜单默认所属的角色，平台实体只能对应平台管理员，租户实体可以对应应用管理员和应用用户 */
  private _roleType: EnumRoleType;

  /** 设置：所属角色 */
  public get roleType() {
    return this._roleType;
  }

  /** 获取：所属角色 */
  public set roleType(value: EnumRoleType) {
    this._roleType = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: APPComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: APPComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 菜单主子关系集合（当前为主菜单集） */
  private _mainMenuContains: Array<MenuContain>;

  /** 获取：菜单主子关系集合（当前为主菜单集） */
  public get mainMenuContains() {
    return this._mainMenuContains;
  }

  /** 设置：菜单主子关系集合（当前为主菜单集） */
  public set mainMenuContains(value: Array<MenuContain>) {
    this._mainMenuContains = value;
  }

  /** 菜单主子关系集合（当前为子菜单集） */
  private _subMenuContains: Array<MenuContain>;

  /** 获取：菜单主子关系集合（当前为子菜单集） */
  public get subMenuContains() {
    return this._subMenuContains;
  }

  /** 设置：菜单主子关系集合（当前为子菜单集） */
  public set subMenuContains(value: Array<MenuContain>) {
    this._subMenuContains = value;
  }

  /** 菜单项 */
  private _menuItems: Array<MenuItem>;

  /** 获取：菜单项 */
  public get menuItems() {
    return this._menuItems;
  }

  /** 设置：菜单项 */
  public set menuItems(value: Array<MenuItem>) {
    this._menuItems = value;
  }

  constructor() {
    super();
    this._icon = '';
    this._isValid = true;
    this._code = '';
    this._isDefault = true;
    this._displaySequence = 0;
    this._roleType = EnumRoleType.AppManager;
    this._component_ID = '';
    this._component = null;
    this._mainMenuContains = new Array<MenuContain>();
    this._subMenuContains = new Array<MenuContain>();
    this._menuItems = new Array<MenuItem>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MenuSet, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.icon = element.icon;
      this.isValid = element.isValid;
      this.code = element.code;
      this.isDefault = element.isDefault;
      this.displaySequence = element.displaySequence;
      this.roleType = element.roleType;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.icon = json.Icon;
    this.isValid = json.IsValid;
    this.code = json.Code;
    this.isDefault = json.IsDefault;
    this.displaySequence = json.DisplaySequence;
    this.roleType = json.RoleType as EnumRoleType;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = APPComponent.Create(json.Component);
    // }
    if (json.MainMenuContains && json.MainMenuContains.length > 0) {
      json.MainMenuContains.forEach((element: any) => {
        const menuContain = MenuContain.Create(element);
        // menuContain.mainMenuSet = this;
        this.mainMenuContains.push(menuContain);
      });
    }
    if (json.SubMenuContains && json.SubMenuContains.length > 0) {
      json.SubMenuContains.forEach((element: any) => {
        const menuContain = MenuContain.Create(element);
        // menuContain.subMenuSet = this;
        this.subMenuContains.push(menuContain);
      });
    }
    if (json.MenuItems && json.MenuItems.length > 0) {
      json.MenuItems.forEach((element: any) => {
        const menuItem = MenuItem.Create(element);
        // menuItem.menuSet = this;
        this.menuItems.push(menuItem);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Icon = this.icon;
    json.IsValid = this.isValid;
    json.Code = this.code;
    json.IsDefault = this.isDefault;
    json.DisplaySequence = this.displaySequence;
    json.RoleType = this.roleType;
    json.Component_ID = this.component_ID;
    if (this.mainMenuContains && this.mainMenuContains.length > 0) {
      json.MainMenuContains = [];
      this.mainMenuContains.forEach((element) => {
        json.MainMenuContains.push(element.toJson());
      });
    }
    if (this.subMenuContains && this.subMenuContains.length > 0) {
      json.SubMenuContains = [];
      this.subMenuContains.forEach((element) => {
        json.SubMenuContains.push(element.toJson());
      });
    }
    if (this.menuItems && this.menuItems.length > 0) {
      json.MenuItems = [];
      this.menuItems.forEach((element) => {
        json.MenuItems.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'icon', '图标地址', EnumDataType.String, this.icon, true, '图标地址', '', '');
    context.addRow('基本属性', 'isValid', '是否启用', EnumDataType.Bool, this.isValid, true, '是否启用', '', '');
    context.addRow('基本属性', 'isDefault', '是否默认', EnumDataType.Bool, this.isDefault, true, '是否默认的菜单集，只有根菜单集有效', '', '');
    context.addRow('基本属性', 'displaySequence', '显示顺序', EnumDataType.Int, this.displaySequence, true, '显示顺序，升序', '', '');
    context.addRow('基本属性', 'roleType', '所属角色', EnumDataType.Reference, this.roleType, true, '仅作用于根菜单。菜单默认所属的角色，平台实体只能对应平台管理员，租户实体可以对应应用管理员和应用用户', 'EnumRoleType', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): MenuSet {
    const menuSet = new MenuSet();
    menuSet.Deserialize(json);
    menuSet.json = json;
    return menuSet;
  }
}
